import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

interface Herbicide {
  herbicide_id: string
  herbicide_dose: number
}

export interface EditHerbicideTreatmentPayload {
  treatment_name: string
  herbicides: Herbicide[]
  treatment_cost: number
}

export async function editHerbicideTreatment(
  id: string,
  payload: EditHerbicideTreatmentPayload,
) {
  await companiesApi.put(apiRoutes.editHerbicideTreatment(id), payload)
}
